export const BACKEND_ENDPOINT =
  'https://deeply-website-backend-972214006976.asia-northeast3.run.app';

export const BACKEND_PROXY_PATH = '/api/backend';
